import { getResolvedLocale } from '../date/localize.js';

export function formatNumber(value: number, opts: Intl.NumberFormatOptions = {}, locale?: string): string {
  return new Intl.NumberFormat(locale ?? getResolvedLocale(), opts).format(value);
}

export function formatPercent(value: number, fractionDigits = 0, locale?: string): string {
  return new Intl.NumberFormat(locale ?? getResolvedLocale(), {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(value);
}

export function formatCompact(value: number, locale?: string): string {
  return new Intl.NumberFormat(locale ?? getResolvedLocale(), {
    notation: 'compact',
    maximumFractionDigits: 1
  }).format(value);
}

const ORDINAL_RULES: Record<string, string> = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th'
};

export function formatOrdinal(value: number, locale?: string): string {
  try {
    const pr = new Intl.PluralRules(locale ?? getResolvedLocale(), { type: 'ordinal' });
    return `${value}${ORDINAL_RULES[pr.select(value)] ?? 'th'}`;
  } catch {
    return `${value}th`;
  }
}
